import { useState } from 'react';

import { useGetProductArrangementsQuery, TotadminPermission } from 'data/__generated__';

import { DataTable } from 'components/DataTable';
import { Loader } from 'components/Loader';
import { TotemPrimaryButton } from 'components/TotemPrimaryButton';
import { ArchiveProductArrangementsPopup } from '../Popups/ArchiveProductArrangementsPopup';

import { productArrangementsColumns, type ProductArrangementRow } from '../constants/productArrangementsColumns';

export const ProductArrangementsList = () => {
    const [selectedKeys, setSelectedKeys] = useState<string[]>([]);
    const [isArchivePopupOpen, setIsArchivePopupOpen] = useState<boolean>(false);

    const {
        loading: productArrangementsLoading,
        data: productArrangementsData,
        error: productArrangementsError,
    } = useGetProductArrangementsQuery();

    if (productArrangementsLoading && !productArrangementsData) {
        return (
            <div className="flex h-full w-full items-center justify-center">
                <Loader />
            </div>
        );
    }

    if (productArrangementsError || !productArrangementsData) {
        throw new Error('Une erreur est survenue lors de la récupération des gammes de produits');
    }

    const { productArrangementsQuery: productArrangements } = productArrangementsData;

    const rows: ProductArrangementRow[] = productArrangements.map((arrangement) => ({
        ...arrangement,
        numberOfProducts: arrangement.productIdsWithStockMax.length,
    }));

    const archiveButton =
        selectedKeys.length > 0 ? (
            <TotemPrimaryButton
                onClick={() => setIsArchivePopupOpen(true)}
                requiredPermissions={[TotadminPermission.ProductArrangementsManage]}
            >
                Archiver {selectedKeys.length > 1 ? 'ces gammes de produit' : 'cette gamme de produit'}
            </TotemPrimaryButton>
        ) : null;

    return (
        <div className="flex h-full w-full flex-col overflow-hidden">
            <DataTable<ProductArrangementRow>
                columns={productArrangementsColumns}
                data={rows}
                filterMode="client"
                getRowId={(row) => row._id}
                getRowLink={(row) => `/product-arrangement/${row._id}`}
                searchPlaceholder="Nom de la gamme de produits"
                searchFilterKey="searchValue"
                enableSelection
                selectedKeys={selectedKeys}
                onSelectionChange={setSelectedKeys}
                toolbarActions={archiveButton}
            />
            <ArchiveProductArrangementsPopup
                productArrangements={productArrangements}
                selectedProductArrangementIds={selectedKeys}
                setSelectedProductArrangementIds={setSelectedKeys}
                isOpen={isArchivePopupOpen}
                setIsOpen={setIsArchivePopupOpen}
            />
        </div>
    );
};
